<template>
  <div :id="page_slug">
    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item>Template Categories</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <div class="actions-bar">
      <el-row>
        <el-col :span="8">
          <el-input placeholder="Search By Name" v-model="search_terms">
            <template slot="append"><el-button slot="append" icon="el-icon-search"></el-button></template>
          </el-input>
        </el-col>

        <el-col :span="14" :offset="2" class="text-right">
          <el-dropdown trigger="click" :hide-on-click="false">
            <el-tooltip class="item" effect="light" content="Show or hide columns" placement="top">
              <el-button>
                Columns <i class="el-icon-caret-bottom"></i>
              </el-button>
            </el-tooltip>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(column, index) in columns" :key="index">
                <el-checkbox v-model="columns[index]">{{index | prettyIndexName}}</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <router-link :to="{ name: 'TemplateCategoryAdd' }">
            <el-button :disabled="!hasRole('template_categories.can_add')" type="default">Add Template Category</el-button>
          </router-link>
        </el-col>
      </el-row>
    </div>

    <el-row>
      <el-table
        v-loading="loading"
        :data="template_category"
        border
        style="width: 100%">

        <el-table-column
          v-if="columns.id"
          width="115%"
          prop="id"
          label="ID">
        </el-table-column>

        <el-table-column
          v-if="columns.name"
          prop="name"
          label="Category Name">
        </el-table-column>

        <el-table-column
          v-if="columns.url_name"
          prop="url_name"
          label="Category URL">
        </el-table-column>

        <el-table-column
          v-if="columns.created_at"
          align="center"
          width="115%"
          prop="created_at"
          label="Created Date">
          <template slot-scope="scope">
            {{scope.row.created_at | moment(config.date_format_compact)}}
          </template>          
        </el-table-column>

        <el-table-column
          v-if="columns.updated_at"
          align="center"
          width="115%"
          prop="updated_at"
          label="Updated Date">
            <template slot-scope="scope">
            {{scope.row.updated_at | moment(config.date_format_compact)}}
            </template>          
        </el-table-column>

        <el-table-column
          align="center"
          width="115%"
          label="Actions">
          <template slot-scope="scope">
            <router-link :to="{ name: 'TemplateCategoryEdit', params: { id: scope.row.id }}">
              <el-button 
              :disabled="!hasRole('template_categories.can_edit')"
              icon="el-icon-edit"
              type="default" 
              size="small"></el-button>
            </router-link>
          </template>
        </el-table-column>

      </el-table>
    </el-row>

    <el-row :gutter="0">
      <el-col :span="24" :xs="24" :sm="24" class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.current_page"
          :page-count="pagination.total_pages"
          :page-size="pagination.per_page"
          layout="total, prev, pager, next"
          :total="pagination.total">
        </el-pagination>
      </el-col>
    </el-row>

    <pre>{{$data}}</pre>
  </div>
</template>

<style>
</style>

<script>
  import Config from '@/store/Config.js';
  import Tables from '@/store/Tables.js';
  import store from '@/store/Store.js';

  export default {
    data: function() {
      return {
        page_alias: 'Template Category List',
        page_slug: 'template-category-list',

        permissions: store.permissions,
        config: Config.config,
        columns: Tables.payment_methods.columns,
        order_by: Tables.payment_methods.order_by,
        sort_by: Tables.payment_methods.sort_by,

        loading: false,
        search_terms: '',
        template_category: [],

        pagination: {
          total: 0,
          per_page: 0,
          current_page: 0,
          last_page: 0,
          next_page_url: '',
          prev_page_url: '',
          from: 0,
          to: 0,
        }
      };
    },

    mounted: function() {
      const me = this;
      me.getTemplateCategory();
    },

    methods: {
      hasRole: function(role_name) {
        const me = this;

        if(me.permissions.user_roles.length > 0) {
          /* returns undefined if doesn't find the role */
          var role = _.find(me.permissions.user_roles, function(o) { 
            return o.name == role_name; 
          });

          /* doesn't enter if when undefined */
          if(role) {
            return true
          }
        }
        
        return false;
      },
      
      getTemplateCategory: function(goToPage) {
        console.log('Get Template Category Function');
        const me = this;
        me.loading = true;
        me.$http.get(me.config.api + 'templateCategory', {params: {page: goToPage}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.template_category = response.body.data;
          me.pagination.total = response.body.total;
          me.pagination.per_page = response.body.per_page;
          me.pagination.current_page = response.body.current_page;
          me.pagination.last_page = response.body.last_page;
          me.pagination.next_page_url = response.body.next_page_url;
          me.pagination.prev_page_url = response.body.prev_page_url;
          me.pagination.from = response.body.from;
          me.pagination.to = response.body.to;
          me.loading = false;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
          me.loading = false;
        });
      },

      handleCurrentChange(val) {
        const me = this;
        me.getTemplateCategory(val);
        window.scrollTo(0,0);
      }
    },

    filters: {
      prettyIndexName(text) {
        var prettyName = text.replace(/_/g, ' ').toUpperCase();
        return prettyName
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/template-categories/TemplateCategoryList.vue